import React from 'react'
import MenuIcon from '@mui/icons-material/Menu'

const HamburgerMenuIcon = () => {
	return <MenuIcon />
}

export default HamburgerMenuIcon
